var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "touch",
    {
      on: {
        "swipe-left": function ($event) {
          return _vm.next(true, "scroll-right")
        },
        "swipe-right": function ($event) {
          return _vm.prev(true, "scroll-left")
        },
      },
    },
    [
      _c(
        "div",
        [
          _vm.isBannerVisible
            ? _c(
                "section",
                {
                  staticClass: "gfu-hero-banner",
                  attrs: { role: "region", "aria-label": "Hero banner" },
                  on: {
                    mouseenter: _vm.pauseAutoplay,
                    mouseleave: _vm.resumeAutoplay,
                    focusin: _vm.pauseAutoplay,
                    focusout: _vm.resumeAutoplay,
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "_tc--white",
                      attrs: {
                        href: _vm.currentSlide.url,
                        target: _vm.currentSlide.linkTarget,
                      },
                    },
                    [
                      _c(
                        "transition-group",
                        { attrs: { name: "gfu-hero-fade", mode: "out-in" } },
                        _vm._l(_vm.slides, function (slide, i) {
                          return _c(
                            "div",
                            {
                              key: slide.id,
                              class: [
                                "gfu-hero-banner__slide",
                                { "is-active": i === _vm.currentIndex },
                              ],
                              style: _vm.bgStyle(slide.imageUrl),
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "gfu-hero-banner__content gfu-homepage-wrapper",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "gfu-hero-banner__meta _tc--white",
                                    },
                                    [
                                      slide.labelText
                                        ? _c(
                                            "base-label",
                                            { staticClass: "_mb-1" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(slide.labelText) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "gfu-hd gfu-hd--h1 _tc--white",
                                        },
                                        [_vm._v(_vm._s(slide.header))]
                                      ),
                                      _vm._v(" "),
                                      slide.hasCustomContent
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "_mt-2" },
                                              _vm._l(
                                                slide.content,
                                                function (line, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "_flex _gap-1 _ai-c _fw-b gfu-bt--b1 _mb-1",
                                                    },
                                                    [
                                                      _c("base-icon", {
                                                        attrs: {
                                                          name: line.icon,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass: "_mt-0",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              line.content
                                                            ) + " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        : [
                                            _c("p", {
                                              staticClass: "_mt-1",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  slide.content
                                                ),
                                              },
                                            }),
                                          ],
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "nav",
                    {
                      staticClass: "gfu-hero-banner__nav",
                      attrs: { "aria-label": "Slide navigation" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "gfu-hero-banner__nav-viewport" },
                        [
                          _c(
                            "ul",
                            {
                              staticClass: "gfu-hero-banner__nav-track",
                              style: _vm.trackStyle,
                            },
                            _vm._l(_vm.slides, function (slide, i) {
                              return _c(
                                "li",
                                {
                                  key: slide.id,
                                  staticClass: "gfu-hero-banner__nav-item",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "gfu-hero-banner__thumb",
                                      class: {
                                        "gfu-hero-banner__thumb--active":
                                          i === _vm.currentIndex,
                                      },
                                      attrs: {
                                        "aria-label":
                                          "Show slide " + slide.header,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goTo(i)
                                        },
                                      },
                                    },
                                    [
                                      _c("base-image", {
                                        staticClass:
                                          "gfu-hero-banner__thumb-image",
                                        attrs: {
                                          src: slide.thumbnailImageUrl,
                                          alt: "thumbnail: " + slide.header,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.isLessThanL && _vm.slides.length > 1
                        ? _c(
                            "div",
                            { staticClass: "gfu-hero-banner__nav-buttons" },
                            [
                              _c(
                                "base-button",
                                {
                                  staticClass: "_ba-0",
                                  attrs: {
                                    "aria-label":
                                      _vm.Resources.Common
                                        .ScrollLeftButtonLabel,
                                    theme: "white",
                                    shape: "circle",
                                    shadow: "tight",
                                    "data-qa": "left-arrow-button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.prev(true, "scroll-left")
                                    },
                                  },
                                },
                                [
                                  _c("base-icon", {
                                    staticClass: "_tc--accent",
                                    attrs: { name: "chevron-left", size: "lg" },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "base-button",
                                {
                                  staticClass: "_ba-0",
                                  attrs: {
                                    "aria-label":
                                      _vm.Resources.Common
                                        .ScrollRightButtonLabel,
                                    theme: "white",
                                    shape: "circle",
                                    shadow: "tight",
                                    "data-qa": "right-arrow-button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.next(true, "scroll-right")
                                    },
                                  },
                                },
                                [
                                  _c("base-icon", {
                                    staticClass: "_tc--accent",
                                    attrs: {
                                      name: "chevron-right",
                                      size: "lg",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _c("skeleton-hero-banner"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }